import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import moment from "moment";
import config from "../../../config";
import { PDFViewer } from "@react-pdf/renderer";
import { Spin } from "antd";
import { AccountLedgerPdfDocument } from "./AccountLedgerPdf";

const parseBoolParam = (value) =>
  value === true || value === "true" || value === "1";

const resolveReportDate = (raw) => {
  if (!raw || raw === "null" || raw === "undefined") return null;
  const parsed = moment(raw, ["YYYY-MM-DD", config.date_format], true);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
};

function PrintAccountLedger() {
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");

  const urlParams = new URLSearchParams(window.location.search);
  const accountId = urlParams.get("account_id");
  const printType = urlParams.get("PrintType") || "All";
  const startDate = resolveReportDate(urlParams.get("StartDate"));
  const endDate = resolveReportDate(urlParams.get("EndDate"));
  const accountNameFromUrl = urlParams.get("Name");

  const columnFlags = useMemo(
    () => ({
      product: parseBoolParam(urlParams.get("Product")),
      rate: parseBoolParam(urlParams.get("Rate")),
      quantity: parseBoolParam(urlParams.get("Quantity")),
      description: parseBoolParam(urlParams.get("Discription")),
    }),
    [urlParams]
  );

  const [loading, setLoading] = useState(true);
  const [accountName, setAccountName] = useState(accountNameFromUrl || "");
  const [ledgerRaw, setLedgerRaw] = useState([]);

  useEffect(() => {
    document.title = "Print Account Ledger";
    if (!UserID || !AccessKey || !accountId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const payload = {
      UserID,
      AccessKey,
      PageSize: 100000,
      PageNo: 1,
      ID: accountId,
    };
    if (startDate) payload.StartDate = startDate;
    if (endDate) payload.EndDate = endDate;

    Promise.all([
      axios({
        method: "post",
        url: config.base_url + "account/GetAccountLedger",
        headers: { "Content-Type": "application/json" },
        data: payload,
      }),
      axios({
        method: "post",
        url: config.base_url + "account/GetAccountbyID",
        headers: { "Content-Type": "application/json" },
        data: { UserID, AccessKey, ID: accountId },
      }),
    ])
      .then(([ledgerRes, accountRes]) => {
        if (ledgerRes.data.status_code == 1) {
          setLedgerRaw(ledgerRes.data.listofLedger || []);
        } else {
          setLedgerRaw([]);
        }
        if (accountRes.data.status_code == 1 && accountRes.data.Name) {
          setAccountName(accountRes.data.Name);
        }
      })
      .catch(() => {
        setLedgerRaw([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [UserID, AccessKey, accountId, startDate, endDate]);

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%">
          <AccountLedgerPdfDocument
            accountName={accountName}
            ledgerRaw={ledgerRaw}
            printType={printType}
            columnFlags={columnFlags}
            startDate={startDate}
            endDate={endDate}
          />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintAccountLedger;
